// extracted by mini-css-extract-plugin
module.exports = {"priceFilter":"_2rOMQ4nmEabyqHUq3Y8Lve","priceFields":"_13Qo1kSbGQWcBwhfmadZ7p"};